// extracted by mini-css-extract-plugin
export default {"pagination":"CustomPagination_pagination__vbt1n","ellipsis":"CustomPagination_ellipsis__79qjn","arrow":"CustomPagination_arrow__X3twl"};